<template>
 <!-- 合作伙伴 -->
  <div class="content-item white">
    <div class="content-items">
      <p class="title">Select device brand</p>
      <div class="breadcrumb">
        <breadcrumb v-if="isModelShow" urlName="Check model" @goBack="goBack"></breadcrumb>
      </div> 
      <div class="service-list partner-list" v-if="isMaxScreen">
        <template v-if="!isModelShow">
          <div v-for="(item, index) in brandList" @click="checkModel(item.brandId)">
            <div class="partner-item brandList">
              <img :src="item.brandLogo" alt="">  
              <span>{{ item.name }}</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div v-for="(item, index) in modelList">
            <div class="partner-item productList">
              <img :src="item.productLogo" alt="">  
              <span>{{ item.name }}</span>
            </div>
          </div>
        </template>
      </div>
      <div class="service-list partner-list" v-else>
        <template v-if="!isModelShow">
          <div v-for="(item, index) in brandList" @click="checkModel(item.brandId)">
            <div class="partner-item brandList">
              <img :src="item.brandLogo" alt="">  
              <span>{{ item.name }}</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div v-for="(item, index) in modelList">
            <div class="partner-item productList">
              <img :src="item.productLogo" alt="">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import breadcrumb from './../breadcrumb/breadcrumb.vue'
// import { getBrandList, getModelList } from '..//services/apis/brandList'
import { getBrandList, getModelList } from './../../services/api/brandList'
export default {
  name: 'partner-part',
  components: {
    breadcrumb
  },
  data () {
    return {
      brandList: [],
      modelList: [],
      isModelShow: false
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => state.isMaxScreen
    })
  },
  created(){
    this.getBrandList()
  },
  methods: {
    changeIndex (index) {
      this.itemIndex = index;
    },
    goBack(){
      console.log(123456)
      this.isModelShow = false;
    },
    getBrandList(){
      getBrandList({
        categoryId: 2,
        pageSize: 100,
        currentPage: 1
      }).then(res => {
        console.log(res.list)
        this.brandList = res.list
        this.list = res.list
      })
    },
    checkModel(brandId){
      getModelList({
        categoryId: 2,
        brandId: brandId,
        pageSize: 100,
        currentPage: 1
      }).then(res => {
        this.isModelShow = true;
        this.modelList = res.list
      })
    }
  }
};
</script>

<style lang="less" scoped>
@media (max-width: 980px) {
  .home {
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    .content-item {
      display: flex;
      flex-direction: column;
      padding: 0 24px;
      .content-items {
        padding-top: 55px;
        box-sizing: border-box;
        p {
          margin: 0;
          padding: 0;
          text-align: left;
          font-size: 32px;
        }
        .title {
          margin-bottom: 52px;
          font-size: 32px;
          line-height: 32px;
          color: #333;
          font-weight: 550;
          text-align: center;
        }
        .text {
          display: inline-block;
          color: #999;
          font-size: 24px;
          margin-bottom: 11px;
          text-align: left;
        }
        .service-list {
          width: 100%;
          height: 100%;
          background: #fff;
          border-radius: 20px;
          box-sizing: border-box;
          display: flex;
          flex-wrap: wrap;
          align-content: space-between;
          margin-top: 20px;
          // 合作伙伴
          .partner-item {
            width: 220px;
            // height: 160px;

            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            margin-bottom: 52px;
            margin-left: 6px;
            margin-right: 6px;
            
            span {
              margin-top: 15px;
              font-size: 18px;
              color: #282828;
              word-wrap: break-word; /* 当单词太长时自动换行 */
              display: inline-block; /* 将span元素转换为块级元素，以便设置宽度 */
              max-width: 100%; /* 设置span元素的最大宽度 */
              line-height: 1.2;
              flex: 1;
            }
          }

          .brandList{
            img {
              width: auto;
              height: 106px;
            }
          }

          .productList{
            img {
              width: auto;
              height: 150px;
            }
          }

          // .partner-item:nth-child(3n+2){
          //   margin: 0 ;
          // }
        }
      }
    }
  }
}
@media (min-width: 981px) {
  .home {
    width: 100%;
    .main-content {
      width: 100%;
      .white {
        background: white;
      }
      .gray {
        background: #F6F6F6;
      }
      .content-item {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .breadcrumb{
        margin: 36px 0;
      }
      
      .content-items {
        width: 1200px;
        padding: 90px 0;
        box-sizing: border-box;
        .title {
          font-size: 36px;
          font-weight: 500;
          color: #111111;
          line-height: 36px;
          text-align: center;
          margin: 0;
        }
        .text {
          display: inline-block;
          font-size: 22px;
          margin-top: 20px;
        }
        .service-list {
          margin-top: 55px;
          display: flex;
          flex-wrap: wrap;
          align-content: space-between;
          // 合作伙伴
          .partner-item {
            width: 240px;
            // height: 160px;
            margin: 0px 0px 52px 0px;
            text-align: center;
            line-height: 64px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            span {
              margin-top: 15px;
              font-size: 18px;
              color: #282828;
              word-wrap: break-word; /* 当单词太长时自动换行 */
              display: inline-block; /* 将span元素转换为块级元素，以便设置宽度 */
              max-width: 100%; /* 设置span元素的最大宽度 */
              line-height: 1.2;
              flex: 1;
            }
          }
          // .partner-item:nth-child(5n) {
          //   margin-right: 0;
          // }
          .brandList{
            img {
              width: auto;
              height: 86px;
            }
          }

          .productList{
            img {
              width: auto;
              height: 180px;
            }
          }
        }
        .more {
          width: 100%;
          height: 64px;
          font-size: 24px;
          color: #999;
          text-align: center;
          line-height: 64px;
        }
      }
    }
  }
}
</style>
